import React from "react";

const ResourceAllocation = () => {
  return <div>ResourceAllocation</div>;
};

export default ResourceAllocation;
